import { useState, useMemo } from 'react';
import { useClient } from '../../../context/client';
import { useAsyncEffect } from '../../../hooks';

const ALLOWED_CUSTOMER_GROUPS = ['US Retail', 'CAN Retail'];

export function useProductTypesAndCustomerGroups(selectedCustomer) {
	const [isLoading, setIsLoading] = useState(false);
	const client = useClient();
	const [categories, setCategories] = useState([]);
	const [groups, setGroups] = useState([]);

	const customerGroups = useMemo(
		() =>
			selectedCustomer?.customer_group_id
				? groups
				: groups?.filter(({ name }) =>
						ALLOWED_CUSTOMER_GROUPS.includes(name),
				  ),
		[selectedCustomer, groups],
	);

	useAsyncEffect(async () => {
		setIsLoading(true);

		try {
			const { categories, groups } =
				await client.getCategoryAndGroupFilters();
			setCategories(
				categories.map(({ id, name }) => ({
					value: id,
					content: name,
				})),
			);
			setGroups(groups);
		} catch {
			setCategories([]);
			setGroups([]);
		}

		setIsLoading(false);
	});

	return [isLoading, categories, customerGroups];
}
